import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Divider } from 'semantic-ui-react';
import {
  Answer,
  Grid,
  Icon,
  Link,
  Name,
  NoResults,
} from './styles';

import BaseChartCard from '../base-chart-card';
import TimeOnQuestion from '../time-on-question';

const WrittenResponseChart = (props) => {
  const {
    data, projectId, title,
  } = props;

  const {
    id,
    label,
    questionOrder,
    writtenAndTranscriptAnswers,
    averageTime,
  } = data;

  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);

  const handleSearchChange = ({ value }) => {
    setSearch(value === ' ' ? _.trim(value) : value);
  };

  /**
   * Written answers search
   */
  useEffect(() => {
    if (search) {
      const searchFormated = _.toLower(search);
      const responses = searchFormated && _.filter(writtenAndTranscriptAnswers, (item) => (
        _.includes(_.toLower(item.firstName), searchFormated)
        || _.includes(_.toLower(item.valueText), searchFormated)
      ));
      setResults(responses);
    } else {
      setResults(writtenAndTranscriptAnswers);
    }
  }, [search, writtenAndTranscriptAnswers]);

  return (
    <BaseChartCard
      onSearchChange={({ target }) => handleSearchChange(target)}
      search={search}
      questionTitle={`Question ${questionOrder + 1}`}
      questionLabel={label}
      questionType={title}
      questionId={id}
    >
      <Grid>
        {
          results.map((item) => (
            <Grid.Row key={`${item.testerId}-${item.videoStartTime}`}>
              <Grid.Column width={2}>
                <Name>{item.firstName}</Name>
              </Grid.Column>
              <Grid.Column width={12}>
                <Answer>
                  {item.valueText}
                </Answer>
              </Grid.Column>
              <Grid.Column witdh={2}>
                <Link href={`/projects/${projectId}/videos/${item.testerId}?time=${item.videoStartTime}`} target="_blank">
                  Watch
                  <Icon name="caret right" />
                </Link>
              </Grid.Column>
            </Grid.Row>
          ))
        }
        {
          _.isEmpty(results) && (
            <NoResults>
              No results found
            </NoResults>
          )
        }
      </Grid>
      <Divider />
      {!_.isEmpty(writtenAndTranscriptAnswers) && (
        <TimeOnQuestion
          data={writtenAndTranscriptAnswers}
          averageTime={averageTime}
          projectId={projectId}
        />
      )}
    </BaseChartCard>
  );
};

WrittenResponseChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    testers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  })).isRequired,
  projectId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default WrittenResponseChart;
